// SECTION - auth
export const GET_TOKEN = 'GET_TOKEN'
export const GET_IS_LOGGED_IN = 'GET_IS_LOGGED_IN'
// SECTION - app
export const GET_USER = 'GET_USER'
// SECTION - setting
export const GET_THEME = 'GET_THEME'
export const GET_SYSTEM_THEME = 'GET_SYSTEM_THEME'
export const GET_IS_DARK_MODE = 'GET_IS_DARK_MODE'
export const GET_LANGUAGE = 'GET_LANGUAGE'
// SECTION - electron
export const GET_UPDATE_STATUS = 'GET_UPDATE_STATUS'
export const GET_UPDATE_AVAILABLE_VERSION = 'GET_UPDATE_AVAILABLE_VERSION'
export const GET_APP_VERSION = 'GET_APP_VERSION'
export const GET_UPDATE_ERROR_MESSAGE = 'GET_UPDATE_ERROR_MESSAGE'
export const GET_UPDATE_DOWNLOAD_PROGRESS = 'GET_UPDATE_DOWNLOAD_PROGRESS'